import { type ReactNode } from 'react';
import { useLoyaltyToast } from '../../../../redux/loyalty/toast/loyaltyToastHooks';
import { IconCheckCircle, IconXCircle, IconAlertTriangle, IconInfo } from './Icons';

const variantConfig: Record<string, { bg: string; border: string; icon: ReactNode }> = {
  success: { bg: 'var(--green-soft)', border: 'var(--green)', icon: <IconCheckCircle size={16} color="var(--green)" /> },
  error: { bg: 'var(--red-soft)', border: 'var(--red)', icon: <IconXCircle size={16} color="var(--red)" /> },
  warning: { bg: 'var(--orange-soft)', border: 'var(--orange)', icon: <IconAlertTriangle size={16} color="var(--orange)" /> },
  info: { bg: 'var(--accent-soft)', border: 'var(--accent)', icon: <IconInfo size={16} color="var(--accent)" /> },
};

function ToastChip({ toast, onRemove }: { toast: import('../../../../redux/loyalty/toast/loyaltyToastTypes').Toast; onRemove: () => void }) {
  const config = variantConfig[toast.variant] || variantConfig.info;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '10px 16px',
        background: 'var(--surface)',
        border: '1px solid var(--card-border)',
        borderLeft: `3px solid ${config.border}`,
        borderRadius: 8,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        fontSize: 13,
        color: 'var(--t1)',
        minWidth: 280,
        maxWidth: 400,
        animation: 'slideIn 0.2s ease-out',
      }}
    >
      <span style={{ display: 'inline-flex', flexShrink: 0 }}>{config.icon}</span>
      <span style={{ flex: 1 }}>{toast.message}</span>
      <button
        onClick={onRemove}
        style={{ color: 'var(--t3)', fontSize: 16, lineHeight: 1, padding: 2, flexShrink: 0, background: 'none', border: 'none', cursor: 'pointer' }}
      >
        &times;
      </button>
    </div>
  );
}

export function ToastContainer() {
  const { toasts, removeToast } = useLoyaltyToast();

  if (toasts.length === 0) return null;

  const bottomRight = toasts.filter((t) => !t.position || t.position === 'bottom-right');
  const bottomCenter = toasts.filter((t) => t.position === 'bottom-center');

  return (
    <>
      {bottomRight.length > 0 && (
        <div style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 200, display: 'flex', flexDirection: 'column', gap: 8 }}>
          {bottomRight.map((toast) => (
            <ToastChip key={toast.id} toast={toast} onRemove={() => removeToast(toast.id)} />
          ))}
        </div>
      )}
      {bottomCenter.length > 0 && (
        <div style={{ position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)', zIndex: 200, display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'center' }}>
          {bottomCenter.map((toast) => (
            <ToastChip key={toast.id} toast={toast} onRemove={() => removeToast(toast.id)} />
          ))}
        </div>
      )}
    </>
  );
}
